export default __webpack_public_path__ + "static/media/s4_title-winters.9dd8e960.png";